import React, { useEffect, useRef } from 'react';

const WalletPickerModal = ({ options, onSelect, onClose }) => {
  const dialog = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    dialog.current?.querySelector('button')?.focus();
    return () => previous?.focus?.();
  }, []);
  const onKeyDown = event => {
    if (event.key === 'Escape') { event.preventDefault(); onClose(); }
    if (event.key !== 'Tab') return;
    const buttons = Array.from(dialog.current.querySelectorAll('button:not(:disabled), a[href]'));
    const first = buttons[0], last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />
      <div
        className="relative z-10 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl"
        ref={dialog}
        onKeyDown={onKeyDown}
        role="dialog"
        aria-modal="true"
        aria-label="Connect a wallet"
      >
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-bold text-gray-900">Connect a wallet</h3>
          <button
            onClick={onClose}
            className="text-gray-400 transition-colors hover:text-gray-600"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {options.length === 0 && <p className="mb-4 text-sm text-gray-600">No browser wallet detected. Open this page in your wallet’s browser, or enable a browser wallet extension and reload.</p>}
        <div className="space-y-2">
          {options.map((opt) => (
            <button
              key={opt.id}
              onClick={() => onSelect(opt)}
              className="flex w-full items-center gap-3 rounded-xl border border-gray-200 px-4 py-3 text-left transition-all hover:border-blue-400 hover:bg-blue-50"
            >
              {opt.icon ? (
                <img src={opt.icon} alt="" className="h-7 w-7 rounded-md" />
              ) : (
                <span aria-hidden="true" className="flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-r from-blue-600 to-purple-600 text-sm font-bold text-white">
                  {opt.name.charAt(0).toUpperCase()}
                </span>
              )}
              <span className="font-semibold text-gray-800">{opt.name}</span>
            </button>
          ))}
        </div>

        <p className="mt-4 text-center text-xs text-gray-400">
          Don&apos;t see your wallet? Unlock its extension, then reload.
        </p>
      </div>
    </div>
  );
};

export default WalletPickerModal;
